import React from "react";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";

const PillarTableEmptyTable = <T = any,>() => {
  const {
    columns,
    loadedFirstTime,
    tableRowResults,
    emptyTableMessage,
    dataQueryError,
  } = usePillarTableContext();
  // A failed load has no rows either, but PillarTableError is already saying
  // why - claiming there are no records would be a second, wrong answer.
  if (loadedFirstTime && !dataQueryError && tableRowResults.length === 0) {
    return (
      <tr className="pillartable-table-row-general bg-neutral-light">
        <td colSpan={columns.length + 1}>
          <div className="flex justify-center items-center">
            {emptyTableMessage ?? "No records found."}
          </div>
        </td>
      </tr>
    );
  }
  return <></>;
};

export default PillarTableEmptyTable;
